import { Button, Container, Flex, Image, Link, Text } from "@chakra-ui/react";
import Head from "next/head";
import { useEffect, useState } from "react";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const Brochure = () => {
    const [screenSize, getDimension] = useState({
        winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
        winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
    });

    const setDimensions = () => {
        getDimension({
            winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
            winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener("resize", setDimensions);

        return () => {
            window.removeEventListener("resize", setDimensions);
        };
    }, [screenSize]);

    return (
        <>
            <Header />
            <Head>
                <title>Thank You Page | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/" />
                <link rel="alternate" href="https://grupoguia.mx/" hrefLang="es-mx" />
            </Head>
            <Container
                maxW="8xl"
                {...(screenSize.winWidth <= 768 && { paddingInline: "0" })}
                paddingTop="8rem"
                paddingBottom="6rem"
                mx="auto"
            >
                <Flex
                    justifyContent="center"
                    flexDirection="column"
                    alignItems="center"
                    mx={{ base: "1rem", md: "0" }}
                >
                    <Image
                        src="https://media.grupoguia.mx/assets/home-page/icons/icon-check-typ.svg"
                        width="186"
                        height="186"
                        alt="icon"
                    />
                    <Text marginBottom="2rem" fontSize="2xl" fontWeight="700">
                        ¡Gracias por descargar nuestro brochure!
                    </Text>
                    <Button
                        style={{ width: "282px", height: "44px" }}
                        mt={2}
                        py={6}
                        px={2}
                        rounded="full"
                        color="#000"
                        size="sm"
                        right={0}
                        _active={{ bg: "brand.500" }}
                        aria-label="Comenzar requerimiento"
                        bgColor="brand.500"
                        onClick={(e) => {
                            e.preventDefault();
                            window.history.go(-1);
                        }}
                        _hover={{
                            textDecoration: "none",
                            color: "#000",
                            bg: "brand.500",
                        }}
                        asChild
                    >
                        <Link>Regresar a la propiedad</Link>
                    </Button>
                </Flex>
            </Container>
            <Footer visible={true} esGuiaRent={false} />
        </>
    );
};

export default Brochure;
